import { createSlice } from "@reduxjs/toolkit";
import { getMetadata, getPage } from "./notes-pdf-thunk";

const initialState = {
	loadingPdf: {},
	zoom: 90,
	page: 0,
	content: [],
	scrollTo: null,
	hoveredInformation: { id: 0, highlighted: false },
	selection: { ids: [], highlighted: false },
};
const notesPdfSlice = createSlice({
	name: "notesPdf",
	initialState,
	reducers: {
		setLoadingPdf: (state, { payload }) => ({ ...state, loadingPdf: payload }),
		setHoveredInformation: (state, { payload }) => ({ ...state, hoveredInformation: payload }),
		setSelection: (state, { payload }) => ({ ...state, selection: payload }),
		setZoom: (state, { payload }) => ({ ...state, zoom: payload }),
		setPage: (state, { payload }) => ({ ...state, page: payload }),
		setScrollTo: (state, { payload }) => {
			const { page, x1, x2, y1, y2 } = payload;
			return { ...state, scrollTo: { page: page - 1, x1, x2, y1, y2 }, isScrolling: false };
		},
		resetPdf: (state) => ({ ...state, content: [] }),
	},
	extraReducers: (builder) => {
		builder.addCase(getPage.pending, (state, action) => {
			const { page } = action.meta.arg;
			return {
				...state,
				content: [...state.content, { page, isLoading: true }],
			};
		});
		builder.addCase(getPage.fulfilled, (state, action) => {
			const { page } = action.meta.arg;
			const { payload } = action;
			const blobImage = URL.createObjectURL(payload);
			return {
				...state,
				content: state.content.map((c) =>
					c.page === page ? { ...c, page, image: blobImage, isLoading: false } : c
				),
			};
		});
		builder.addCase(getPage.rejected, (state, action) => {
			const { page } = action.meta.arg;
			return {
				...state,
				content: state.content.map((c) =>
					c.page === page ? { ...c, page, image: null, isLoading: false } : c
				),
			};
		});
		builder.addCase(getMetadata.fulfilled, (state, action) => {
			const { page } = action.meta.arg;
			const { payload } = action;
			return {
				...state,
				reloadingPages: [],
				content: state.content.map((c) => (c.page === page ? { ...c, overlay: payload } : c)),
			};
		});
	},
});
export { getPage };
export const { setLoadingPdf, setZoom, setScrollTo, setPage, resetPdf, setHoveredInformation, setSelection } =
	notesPdfSlice.actions;
export default notesPdfSlice.reducer;
